import { lazyStories } from '../storybook'
const JsonViewer = lazyStories(() => import('./json-viewer.stories'))
const Tooltip = lazyStories(() => import('./tooltip.stories'))
const YoutubeEmbed = lazyStories(() => import('./youtube-embed.stories'))
const Separator = lazyStories(() => import('./separator.stories'))
const TypographyScope = lazyStories(() => import('./typography-scope.stories'))
const NumberInput = lazyStories(() => import('./number-input.stories'))
const Pagination = lazyStories(() => import('./pagination.stories'))
const Collapsible = lazyStories(() => import('./collapsible.stories'))
const SidebarTree = lazyStories(() => import('./sidebar-tree.stories'))
const ErrorDetails = lazyStories(() => import('./error-details.stories'))
const Autocomplete = lazyStories(() => import('./autocomplete.stories'))

// Controls:
const Accordion = lazyStories(() => import('./accordion.stories'))
const Button = lazyStories(() => import('./button.stories'))
const IconButton = lazyStories(() => import('./icon-button.stories'))
const Fab = lazyStories(() => import('./fab.stories'))
const Chip = lazyStories(() => import('./chip.stories'))
const Toggle = lazyStories(() => import('./toggle.stories'))
const ToggleGroup = lazyStories(() => import('./toggle-group.stories'))
const Toolbar = lazyStories(() => import('./toolbar.stories'))
// Overlay/navigation:
const Menu = lazyStories(() => import('./menu.stories'))
const Popover = lazyStories(() => import('./popover.stories'))
const Alert = lazyStories(() => import('./alert.stories'))
const Toast = lazyStories(() => import('./toast.stories'))
const Sidebar = lazyStories(() => import('./sidebar.stories'))
const NavBar = lazyStories(() => import('./nav-bar.stories'))
const Dialog = lazyStories(() => import('./dialog.stories'))
const Tabs = lazyStories(() => import('./tabs.stories'))
const Drawer = lazyStories(() => import('./drawer.stories'))
const Sheet = lazyStories(() => import('./sheet.stories'))
const Breadcrumb = lazyStories(() => import('./breadcrumb.stories'))
const TableOfContents = lazyStories(() => import('./table-of-contents.stories'))
// Input:
const Form = lazyStories(() => import('./form.stories'))
const EmojiPicker = lazyStories(() => import('./emoji-picker.stories'))
const Input = lazyStories(() => import('./input.stories'))
const InputField = lazyStories(() => import('./input-field.stories'))
const NumberField = lazyStories(() => import('./number-field.stories'))
const Select = lazyStories(() => import('./select.stories'))
const SearchableSelect = lazyStories(
  () => import('./searchable-select.stories'),
)
const Combobox = lazyStories(() => import('./combobox.stories'))
const Slider = lazyStories(() => import('./slider.stories'))
const RadioGroup = lazyStories(() => import('./radio-group.stories'))
const CheckboxGroup = lazyStories(() => import('./checkbox-group.stories'))
const ChoiceField = lazyStories(() => import('./choice-field.stories'))
const Switch = lazyStories(() => import('./switch.stories'))
const Command = lazyStories(() => import('./command.stories'))
const Table = lazyStories(() => import('./table.stories'))
const Calendar = lazyStories(() => import('./calendar.stories'))
const DatePicker = lazyStories(() => import('./date-picker.stories'))
const Card = lazyStories(() => import('./card.stories'))
const Image = lazyStories(() => import('./image.stories'))
const Chart = lazyStories(() => import('./chart.stories'))
const ChartVisx = lazyStories(() => import('./chart-visx.stories'))
// Other:
const Avatar = lazyStories(() => import('./avatar.stories'))
const Progress = lazyStories(() => import('./progress.stories'))
const LoadingIndicator = lazyStories(() => import('./loading-indicator.stories'))
const Badge = lazyStories(() => import('./badge.stories'))
const Icon = lazyStories(() => import('./icon.stories'))
const Icon3D = lazyStories(() => import('./icon-3d.stories'))
const Text = lazyStories(() => import('./text.stories'))
const Skeleton = lazyStories(() => import('./skeleton.stories'))
const Group = lazyStories(() => import('./group.stories'))
const ScrollArea = lazyStories(() => import('./scroll-area.stories'))
const Resizable = lazyStories(() => import('./resizable.stories'))
const Empty = lazyStories(() => import('./empty.stories'))
const NotFound = lazyStories(() => import('./not-found.stories'))

const Message = lazyStories(() => import('./message.stories'))

const MessageScroller = lazyStories(() => import('./message-scroller.stories'))

const Bubble = lazyStories(() => import('./bubble.stories'))

const Marker = lazyStories(() => import('./marker.stories'))

export default {
  JsonViewer: { States: JsonViewer.States },
  Marker: { States: Marker.States },
  Bubble: { States: Bubble.States },
  MessageScroller: { States: MessageScroller.States },
  Message: { States: Message.States },
  Tooltip: { States: Tooltip.States },
  YoutubeEmbed: { States: YoutubeEmbed.States },
  Separator: { States: Separator.States },
  TypographyScope: { States: TypographyScope.States },
  NumberInput: { States: NumberInput.States },
  Pagination: { States: Pagination.States },
  Collapsible: { States: Collapsible.States },
  SidebarTree: { States: SidebarTree.States },
  ErrorDetails: { States: ErrorDetails.States },
  Autocomplete: { States: Autocomplete.States },
  // Controls:
  Accordion: {
    States: Accordion.States,
    Default: Accordion.Default,
    Multiple: Accordion.Multiple,
    Controlled: Accordion.Controlled,
  },
  Button: { Default: Button.Default, States: Button.States },
  IconButton: { Default: IconButton.Default, States: IconButton.States },
  Fab: { Default: Fab.Default, States: Fab.States },
  Chip: { Default: Chip.Default, States: Chip.States },
  Toggle: { Default: Toggle.Default, States: Toggle.States },
  ToggleGroup: { States: ToggleGroup.States, Default: ToggleGroup.Default },
  Toolbar: {
    States: Toolbar.States,
    Default: Toolbar.Default,
    Docked: Toolbar.Docked,
    Floating: Toolbar.Floating,
    FloatingBottomCorners: Toolbar.FloatingBottomCorners,
    DockedWithFab: Toolbar.DockedWithFab,
    FloatingWithFab: Toolbar.FloatingWithFab,
    WithDropdown: Toolbar.WithDropdown,
  },
  // Overlay/navigation:
  TableOfContents: { Document: TableOfContents.Document },
  Menu: {
    States: Menu.States,
    Basic: Menu.Basic,
    WithGroups: Menu.WithGroups,
    Select: Menu.Select,
    WithSubmenu: Menu.WithSubmenu,
    Comprehensive: Menu.Comprehensive,
    ContextMenu: Menu.ContextMenu,
    WithRow: Menu.WithRow,
  },
  Popover: {
    States: Popover.States,
    Basic: Popover.Basic,
    WithTitleDescription: Popover.WithTitleDescription,
    TooltipStyle: Popover.TooltipStyle,
    Positioning: Popover.Positioning,
    Animated: Popover.Animated,
  },
  Alert: {
    States: Alert.States,
  },
  Toast: {
    States: Toast.States,
    Basic: Toast.Basic,
    WithAction: Toast.WithAction,
    Positions: Toast.Positions,
    Timeout: Toast.Timeout,
    Anchored: Toast.Anchored,
  },
  Sidebar: {
    States: Sidebar.States,
    Default: Sidebar.Default,
    FloatingVariant: Sidebar.FloatingVariant,
    InsetVariant: Sidebar.InsetVariant,
    CollapsibleIcon: Sidebar.CollapsibleIcon,
    CollapsibleNone: Sidebar.CollapsibleNone,
    RightSide: Sidebar.RightSide,
    Storybook: Sidebar.Storybook,
    WithGroupActions: Sidebar.WithGroupActions,
    WithMenuActions: Sidebar.WithMenuActions,
    WithSearch: Sidebar.WithSearch,
    WithLoadingStates: Sidebar.WithLoadingStates,
    HoverToReveal: Sidebar.HoverToReveal,
  },
  NavBar: { States: NavBar.States, Default: NavBar.Default, WithBadges: NavBar.WithBadges },
  Dialog: {
    States: Dialog.States,
    Basic: Dialog.Basic,
    SemanticVariants: Dialog.SemanticVariants,
    WithPanel: Dialog.WithPanel,
    FullScreen: Dialog.FullScreen,
  },
  Tabs: { States: Tabs.States, Horizontal: Tabs.Horizontal, Vertical: Tabs.Vertical },
  Drawer: {
    States: Drawer.States,
    Directions: Drawer.Directions,
    SnapPoints: Drawer.SnapPoints,
    Nested: Drawer.Nested,
    ActionSheet: Drawer.ActionSheet,
    DetachedTriggers: Drawer.DetachedTriggers,
  },
  Sheet: {
    States: Sheet.States,
    Sides: Sheet.Sides,
    InsetVariant: Sheet.InsetVariant,
    ScrollableContent: Sheet.ScrollableContent,
  },
  Breadcrumb: {
    States: Breadcrumb.States,
    Basic: Breadcrumb.Basic,
    WithEllipsis: Breadcrumb.WithEllipsis,
    CustomSeparator: Breadcrumb.CustomSeparator,
  },
  // Input:
  Form: {
    States: Form.States,
    ValidationModes: Form.ValidationModes,
    FieldUsage: Form.FieldUsage,
    FieldsetUsage: Form.FieldsetUsage,
  },
  EmojiPicker: { States: EmojiPicker.States },
  Input: {
    Types: Input.Types,
    States: Input.States,
    Multiline: Input.Multiline,
    Adornments: Input.Adornments,
    FileUpload: Input.FileUpload,
    Search: Input.Search,
    AutoFocus: Input.AutoFocus,
    Form: Input.Form,
  },
  InputField: {
    States: InputField.States,
    FormValidation: InputField.FormValidation,
  },
  NumberField: { Default: NumberField.Default, States: NumberField.States },
  Select: {
    States: Select.States,
    Basic: Select.Basic,
    Minimal: Select.Minimal,
    WithGroups: Select.WithGroups,
    WithLabel: Select.WithLabel,
    WithDisabledItems: Select.WithDisabledItems,
    SelectContentAlias: Select.SelectContentAlias,
    Controlled: Select.Controlled,
    FormIntegration: Select.FormIntegration,
    DropdownStyle: Select.DropdownStyle,
    WithScrollArrows: Select.WithScrollArrows,
    MultipleSelection: Select.MultipleSelection,
  },
  SearchableSelect: {
    States: SearchableSelect.States,
    Default: SearchableSelect.Default,
    Minimal: SearchableSelect.Minimal,
  },
  Combobox: {
    States: Combobox.States,
    Basic: Combobox.Basic,
    WithStartAddon: Combobox.WithStartAddon,
    WithGroups: Combobox.WithGroups,
    WithSeparator: Combobox.WithSeparator,
    WithStatus: Combobox.WithStatus,
    MultipleChips: Combobox.MultipleChips,
    WithValue: Combobox.WithValue,
    GridLayout: Combobox.GridLayout,
    Controlled: Combobox.Controlled,
    WithObjectValues: Combobox.WithObjectValues,
  },
  Slider: { States: Slider.States, Slider: Slider.Slider, Stops: Slider.Stops },
  RadioGroup: { States: RadioGroup.States, Default: RadioGroup.Default },
  CheckboxGroup: {
    States: CheckboxGroup.States,
    Default: CheckboxGroup.Default,
    FormIntegration: CheckboxGroup.FormIntegration,
  },
  ChoiceField: { States: ChoiceField.States },
  Switch: { States: Switch.States, Default: Switch.Default, FormIntegration: Switch.FormIntegration },
  Command: {
    States: Command.States,
    Basic: Command.Basic,
    WithGroups: Command.WithGroups,
    WithFooter: Command.WithFooter,
    WithDialog: Command.WithDialog,
    WithOverflow: Command.WithOverflow,
    WithOverflowDialog: Command.WithOverflowDialog,
  },
  Table: {
    States: Table.States,
    Basic: Table.Basic,
    WithBadges: Table.WithBadges,
    WithSelection: Table.WithSelection,
    EmptyState: Table.EmptyState,
  },
  Calendar: {
    States: Calendar.States,
    Single: Calendar.Single,
    Multiple: Calendar.Multiple,
    Range: Calendar.Range,
    WithDisabledDates: Calendar.WithDisabledDates,
    WithoutOutsideDays: Calendar.WithoutOutsideDays,
    WithWeekNumbers: Calendar.WithWeekNumbers,
    WithDropdownNavigation: Calendar.WithDropdownNavigation,
    MultipleMonths: Calendar.MultipleMonths,
    WithPresets: Calendar.WithPresets,
  },
  DatePicker: {
    States: DatePicker.States,
    Basic: DatePicker.Basic,
    RangePicker: DatePicker.RangePicker,
    DateOfBirth: DatePicker.DateOfBirth,
    InputDatePicker: DatePicker.InputDatePicker,
  },
  Card: {
    States: Card.States,
    Default: Card.Default,
    Hero: Card.Hero,
    CatAdoption: Card.CatAdoption,
    Small: Card.Small,
    Grid: Card.Grid,
    Clickable: Card.Clickable,
  },
  Image: {
    States: Image.States,
    MissingDisplayUrl: Image.MissingDisplayUrl,
    Basic: Image.Basic,
    Cover: Image.Cover,
    FancyCovers: Image.FancyCovers,
    InGrid: Image.InGrid,
    Thumb: Image.Thumb,
    Gradient: Image.Gradient,
    Uploading: Image.Uploading,
  },
  Chart: {
    States: Chart.States,
    Bar: Chart.Bar,
    Line: Chart.Line,
    Pie: Chart.Pie,
    TooltipIndicators: Chart.TooltipIndicators,
    Customized: Chart.Customized,
  },
  ChartVisx: { States: ChartVisx.States, Bar: ChartVisx.Bar, Line: ChartVisx.Line, Pie: ChartVisx.Pie },
  // Other:
  Avatar: {
    States: Avatar.States,
    Basic: Avatar.Basic,
    Sizes: Avatar.Sizes,
    Group: Avatar.Group,
    AnimatedShapes: Avatar.AnimatedShapes,
  },
  LoadingIndicator: { States: LoadingIndicator.States },
  Progress: {
    States: Progress.States,
    Linear: Progress.Linear,
    Circular: Progress.Circular,
    IndeterminateToDeterminate: Progress.IndeterminateToDeterminate,
  },
  Badge: { Default: Badge.Default, States: Badge.States },
  Icon: {
    States: Icon.States,
    AllIcons: Icon.AllIcons,
    Sizes: Icon.Sizes,
    CustomColor: Icon.CustomColor,
  },
  Icon3D: {
    States: Icon3D.States,
    AllIcons: Icon3D.AllIcons,
    Sizes: Icon3D.Sizes,
    CustomColor: Icon3D.CustomColor,
  },
  Text: { States: Text.States, Inline: Text.Inline },
  Skeleton: {
    States: Skeleton.States,
    Card: Skeleton.Card,
    List: Skeleton.List,
    DataFetching: Skeleton.DataFetching,
  },
  Group: {
    States: Group.States,
    ButtonGroupHorizontal: Group.ButtonGroupHorizontal,
    ButtonGroupVertical: Group.ButtonGroupVertical,
    InputWithText: Group.InputWithText,
    InputWithSelect: Group.InputWithSelect,
  },
  ScrollArea: { States: ScrollArea.States, ScrollArea: ScrollArea.ScrollArea },
  Resizable: { States: Resizable.States, Resizable: Resizable.Resizable },
  Empty: {
    States: Empty.States,
  },
  NotFound: { Default: NotFound.Default },
}
